<template>
    <el-card class="box-card">
        <div class="component-content">
            <el-card v-if="editorAncientCampaign === true">
                <div slot="header" class="clearfix">
                    <span>古记战役数据</span>
                    <el-button-group>
                        <el-button
                            @click="generateAncientCampaignData()"
                            v-clipboard:copy="ancientCampaignData"
                            v-clipboard:success="onCopy"
                            v-clipboard:error="onError">
                            生成最终数据
                        </el-button>
                        <el-button type="warning" @click="parseAncientCampaignData()">解析数据</el-button>
                    </el-button-group>
                </div>
                <el-input type="textarea" v-model="ancientCampaignData"></el-input>
            </el-card>

            <el-card v-if="currentRound != null">
                <!--<div slot="header" class="clearfix">-->
                    <!--<span>阵容数据</span>-->
                <!--</div>-->
                <div slot="header" class="clearfix" v-if="editorAncientCampaign  === true">
                    <span>怪兽数据</span>
                    <el-button-group>
                        <el-button @click="ancientCampaignAddMonster()">添加怪兽</el-button>
                    </el-button-group>
                </div>
                <el-row>
                    <el-col :span="3" v-for="(editMonster, idx) in currentRound.monsters" :key="idx"
                            class="spacing">
                        <el-badge :value="idx + 1" type="info">
                            <div v-if="editMonster.identifier" @click="editMonsterFn(idx)">
                                <el-image style="width: 60px; height: 60px"
                                          :src="'./static/monster_icon/'+editMonster.identifier+'.png'"
                                          fit="cover">
                                </el-image>
                            </div>
                            <!-- <el-button v-if="null != editMonster && editMonster.identifier" type="danger" icon="el-icon-delete" circle size="small" @click="deleteMonster(idx)"></el-button> -->
                            <el-button plain v-else @click="editMonsterFn(idx)">添加</el-button>
                            <el-button plain v-if="null != editMonster && editMonster.identifier"
                                       @click="deleteMonster(idx)" class="del-btn">删除
                            </el-button>
                        </el-badge>
                    </el-col>
                </el-row>

            </el-card>

            <el-dialog title='怪兽' :visible.sync="previewDateShow" width="80%" lock-scroll center>
                <el-card>
                    <div slot="header" class="clearfix">
                        <span>怪兽</span>
                    </div>
                    <el-form class="edit-form" label-suffix=":" label-width="80px">
                        <el-row>
                            <el-col :span="5">
                                <el-form-item label="编号">
                                    <el-select v-model="editMonster.identifier" filterable placeholder='请选择'
                                               @change="handlerMonsterChange(editMonster)">
                                        <el-option v-for="item in monsterConfigs" :key="item.id"
                                                   :label="$t(item.name)"
                                                   :value="item.id">
                                            <el-image style="width: 30px; height: 30px; float: left"
                                                      :src="'./static/monster_icon/'+item.id+'.png'"
                                                      fit="cover"></el-image>
                                            <span style="float: right">{{ $t(item.name) }}</span>
                                        </el-option>
                                    </el-select>
                                </el-form-item>
                            </el-col>
                            <el-col :span="5">
                                <el-form-item label="等级">
                                    <el-input-number v-model.number="editMonster.level" :min="0" :max="200000"/>
                                </el-form-item>
                            </el-col>
                            <el-col :span="5">
                                <el-form-item label="性格">
                                    <el-select v-model="editMonster.temperamentId" placeholder='请选择'>
                                        <el-option v-for="item in monsterTemperamentConfigs" :key="item.id"
                                                   :label="$t(item.name)"
                                                   :value="item.id">
                                        </el-option>
                                    </el-select>
                                </el-form-item>
                            </el-col>
                            <el-col :span="5">
                                <el-form-item label="皮肤">
                                    <el-select v-model="editMonster.skinId">
                                        <el-option
                                            :key="sgt.id"
                                            v-for="(sgt,index) in skinGainType"
                                            :label="getSkinName(sgt)"
                                            :value="sgt.id"
                                            v-if="sgt.monster_identifier===editMonster.identifier || sgt.id === 0">
                                        </el-option>
                                    </el-select>
                                </el-form-item>
                            </el-col>
                        </el-row>

                        <el-form-item label="技能等级">
                            <el-row>
                                <el-col :span="5" v-for="(lv, idx) in editMonster.abilityStarMap"
                                        v-if="currentMonsterConfig && idx <= (currentMonsterConfig.abilities.split(',')).length"
                                        :key="idx">
                                    <span v-if="idx < 9">技能{{ idx }}-等级:</span>
                                    <el-input-number v-model.number="editMonster.abilityStarMap[idx]"
                                                     class="number-spacing"
                                                     :key="idx" :min="1" :max="6"/>
                                </el-col>
                            </el-row>
                        </el-form-item>
                    </el-form>
                </el-card>
                <el-card>
                    <div slot="header" class="clearfix">
                        <span>基因强化</span>
                    </div>
                    <el-form class="edit-form" label-width="70px" label-suffix=":">

                        <el-form-item label="条数">
                            <el-input-number v-model.number="editMonster.strengthenCount"
                                             @change="onStrengthenCountChange(editMonster)"
                                             :min="0"
                                             :max="1 + Math.floor((editMonster.level - 1) / 2) > monsterConfiguration[201].split('#').length ? monsterConfiguration[201].split('#').length : 1 + Math.floor((editMonster.level - 1) / 2)"/>
                            <span>(上限受等级影响)</span>
                        </el-form-item>
                        <el-row>
                            <el-col :span="8">
                                <el-form-item label="小基因">
                                    <el-select v-model="oneClickGenSmall" placeholder='请选择'>
                                        <el-option v-for="item in strengthens"
                                                   :key="item.id" :label="getStrengthenName(item)"
                                                   :value="item.id">
                                        </el-option>
                                    </el-select>
                                    <el-button @click="oneClickGen('small',editMonster)">批量设置</el-button>
                                </el-form-item>
                            </el-col>

                            <el-col :span="8">
                                <el-form-item label="大基因">
                                    <el-select v-model="oneClickGenBig" placeholder='请选择'>
                                        <el-option v-for="item in bigStrengthens"
                                                   :key="item.id" :label="getStrengthenName(item)"
                                                   :value="item.id">
                                        </el-option>
                                    </el-select>
                                    <el-button @click="oneClickGen('big',editMonster)">批量设置</el-button>
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-form-item label="配置">
                            <el-row>
                                <el-col :span="6" v-for="(str, idx) in editMonster.strengthenCount" :key="idx">
                                    <span v-if="idx < 9">基因编号- {{ idx + 1 }}:</span>
                                    <span v-if="idx >= 9">基因编号-{{ idx + 1 }}:</span>
                                    <el-select v-model="editMonster.strengthenList[idx]" placeholder='请选择'>
                                        <el-option
                                            v-for="item in (idx + 1) % parseInt(monsterConfiguration[202]) !== 0 ? strengthens : bigStrengthens"
                                            :key="item.id" :label="getStrengthenName(item)" :value="item.id">
                                        </el-option>
                                    </el-select>
                                </el-col>
                            </el-row>
                        </el-form-item>
                    </el-form>

                </el-card>

                <el-card>
                    <div slot="header" class="clearfix">
                        <span>极化参数配置</span>
                    </div>

                    <el-form class="edit-form" label-width="100px" label-suffix=":">
                        <el-row>
                            <el-col :span="6">
                                <el-form-item label="极化攻击力">
                                    <el-input-number v-model.number="editMonster.plrzAtk" :min="minPlrz"
                                                     :max="maxPlrz"
                                                     :step="0.0001" :precision="4"/>
                                </el-form-item>
                            </el-col>
                            <el-col :span="6">
                                <el-form-item label="极化体力">
                                    <el-input-number v-model.number="editMonster.plrzCon" :min="minPlrz"
                                                     :max="maxPlrz"
                                                     :step="0.0001" :precision="4"/>
                                </el-form-item>
                            </el-col>
                            <el-col :span="6">
                                <el-form-item label="极化霸气">
                                    <el-input-number v-model.number="editMonster.plrzHaki" :min="minPlrz"
                                                     :max="maxPlrz"
                                                     :step="0.0001" :precision="4"/>
                                </el-form-item>
                            </el-col>
                            <el-col :span="6">
                                <el-form-item label="极化移动速度">
                                    <el-input-number v-model.number="editMonster.plrzMspd" :min="minPlrz"
                                                     :max="maxPlrz"
                                                     :step="0.0001" :precision="4"/>
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-form-item label="极化能力条数">
                            <el-input-number v-model="editMonster.editMonsterPlrzAbilitiesLen"
                                             @change="onPlrzCountChange(editMonster)"
                                             :min="0"
                                             :max="parseInt(plrzRange[plrzRange.length - 1].split('_')[0])"/>
                            <span>(选择相同能力会覆盖)</span>
                            <el-row>
                                <el-col :span="12" v-for="(ability,index) in editMonster.plrzAbilitiesMap"
                                        :key="index">
                                    <el-select v-model="ability.identifier" placeholder='请选择'>
                                        <el-option v-for="item in plrzAbilities"
                                                   :key="item.id" :label="$t(item.description)"
                                                   :value="item.id"
                                                   :disabled="handlePlrzAbility(item.id,editMonster.plrzAbilitiesMap)"
                                        >
                                        </el-option>
                                    </el-select>

                                    <span>品质：</span>
                                    <el-select v-model="ability.quality" placeholder='请选择'>
                                        <el-option v-for="item in plrzAbilityQuality" :key="item.id"
                                                   :label="$t(item.name)"
                                                   :value="item.id">
                                        </el-option>
                                    </el-select>
                                </el-col>
                            </el-row>
                        </el-form-item>
                    </el-form>

                </el-card>

                <el-card v-if="editMonster.emblemIn">
                    <div slot="header" class="clearfix">
                        <span>其他 - 元核编辑</span>
                    </div>
                    <el-image v-if="editMonster.emblemIn.baseType > 0" style="width: 60px; height: 60px"
                              :src="'./static/glyph_icon/'+editMonster.emblemIn.quality+'_'+editMonster.emblemIn.baseType+'.png'"
                              fit="cover">
                    </el-image>
                    <el-button @click="editEmblemFn(currentMonsterIdx,'monster')">编辑元核</el-button>
                </el-card>

                <el-card>
                    <div slot="header" class="clearfix">
                        <span>其他 - 增减益设置</span>
                    </div>
                    <el-form label-suffix=":" label-width="100px" class="edit-form">
                        <el-form-item label="增减益条数">
                            <el-input-number v-model="editMonster.editMonsterBonusLen"
                                             @change="onBonusCountChange(editMonster)" :min="0"/>
                        </el-form-item>
                        <el-form-item label="增减益设置">
                            <el-row>
                                <template v-for="(bonus,index) in editMonster.bonus">
                                    <el-col :span="6" class="spacing" :key="index">
                                        <span>增减益- {{ index + 1 }}:</span>
                                        <el-select v-model="bonus.key" :key="index" placeholder='请选择'>
                                            <el-option v-for="item in bonuses" :key="item.value"
                                                       :label="item.name"
                                                       :value="item.value">
                                            </el-option>
                                        </el-select>
                                        <span>系数:</span>
                                        <el-input-number :key="index" v-model.number="bonus.value"/>
                                    </el-col>
                                </template>
                            </el-row>
                        </el-form-item>
                    </el-form>

                </el-card>

                <div slot="footer" class="dialog-footer">
                    <el-button @click="closeDetailLog()">关闭编辑</el-button>
                </div>
            </el-dialog>

            <el-card v-if="editorAncientCampaign  === true">
                <div slot="header" class="clearfix">
                    <span>元核</span>
                    <el-button-group>
                        <el-button @click="ancientCampaignAddEmblem()">添加元核</el-button>
                    </el-button-group>
                </div>
                <el-row>
                    <el-col :span="3" v-for="(editEmblem, idx) in currentRound.editEmblems" :key="idx"
                            class="spacing">
                        <el-badge :value="idx + 1" type="info">
                            <div v-if="editEmblem.baseType > 0" @click="editEmblemFn(idx,'emblem')">
                                <el-image style="width: 60px; height: 60px"
                                          :src="'./static/glyph_icon/'+editEmblem.quality+'_'+editEmblem.baseType+'.png'"
                                          fit="cover">
                                </el-image>
                            </div>
                            <!-- <el-button v-if="null != editMonster && editMonster.identifier" type="danger" icon="el-icon-delete" circle size="small" @click="deleteMonster(idx)"></el-button> -->
                            <el-button plain v-else @click="editEmblemFn(idx,'emblem')">添加</el-button>
                            <el-button plain v-if="null != editEmblem && editEmblem.baseType > 0"
                                       @click="deleteEmblem(idx)" class="del-btn">删除
                            </el-button>
                        </el-badge>
                    </el-col>
                </el-row>
            </el-card>

            <el-dialog title="元核" :visible.sync="previewEmblemDateShow" width="80%" lock-scroll center>
                <el-form class="edit-form">
                    <el-form-item label="主属性:">
                        <el-select v-model="editEmblem.baseType" placeholder='请选择'>
                            <el-option v-for="item in glyphType" :key="item.id"
                                       :label="$t(item.name)+'-'+$t(item.description)"
                                       :value="item.id">
                            </el-option>
                        </el-select>
                    </el-form-item>

                    <el-form-item>
                        <el-form v-if="editEmblem.baseType !== '0'" label-width="60px">
                            <el-form-item label="品质:">
                                <el-select v-model="editEmblem.quality"
                                           @change="onGlyphEntriesCountChange(editEmblem)">
                                    <el-option v-for="item in plrzAbilityQuality" :key="item.id"
                                               :label="$t(item.name)"
                                               :value="item.id">
                                    </el-option>
                                </el-select>
                            </el-form-item>

                            <el-form-item label="等级:">
                                <el-input-number v-model.number="editEmblem.level" :min="0"
                                                 :max="100"
                                                 @change="onGlyphLevelChange(editEmblem)"/>
                                <span>(进阶次数：{{ editEmblem.stage }})</span>
                            </el-form-item>
                            <el-form-item label="宿命:">
                                <el-select v-model="editEmblem.fateType" placeholder='请选择'
                                           @change="changeFateType(editEmblem)">
                                    <el-option v-for="item in glyphFateType" :key=" item.id"
                                               :label="$t(item.name)+'-'+$t(item.description)"
                                               :value="item.id">
                                    </el-option>
                                </el-select>
                                <span v-if="editEmblem.fateType > 0">浮动值:</span>
                                <el-input-number v-if="editEmblem.fateType > 0"
                                                 v-model.number="editEmblem.fateFloatingValue"
                                                 :step="0.0001" :precision="4"
                                                 :min="defaultEntryFloatingValueArr[editEmblem.quality - 1] - 0.05"
                                                 :max="defaultEntryFloatingValueArr[editEmblem.quality - 1] + 0.05"/>
                            </el-form-item>

                            <el-form-item label="词条数:">
                                <el-input-number v-model="editEmblem.editGlyphEntriesLen" :min="1"
                                                 :max="editEmblem.quality"
                                                 @change="glyphEntriesChange(editEmblem)"/>
                                <span>(上限受元核品质影响)</span>
                            </el-form-item>
                            <el-form-item>
                                <el-row>
                                    <el-col :span="16"
                                            v-for="(entry,entryIdx) in editEmblem.entries"
                                            :key="entryIdx">
                                        <span>词条{{ entryIdx + 1 }}:</span>
                                        <el-select v-model="entry.type" placeholder='请选择' size="small">
                                            <!--                                            :label="$t(item.name) +'-'+($t(item.description))"-->
                                            <el-option v-for="item in glyphEntryType" :key="item.id"
                                                       :label="$t(item.name)"
                                                       :value="item.id">
                                                <span style="float: left">{{ $t(item.name) }}</span>
                                                <span style="float: right; color: #8492a6; font-size: 13px">{{
                                                        $t(item.description)
                                                    }}</span>
                                            </el-option>
                                        </el-select>
                                        <span>词条品质{{ entryIdx + 1 }}:</span>
                                        <el-select v-model="entry.quality" placeholder="请选择"
                                                   @change="defaultEntryFloatingValue(entry)">
                                            <el-option v-for="item in plrzAbilityQuality" :key="item.id"
                                                       :label="$t(item.name)"
                                                       :value="item.id">
                                            </el-option>
                                        </el-select>
                                        <span v-if="entry.quality">浮动值:</span>
                                        <el-input-number v-if="entry.quality"
                                                         v-model.number="entry.floatingValue"
                                                         :step="0.0001" :precision="4"
                                                         :min="defaultEntryFloatingValueArr[entry.quality - 1] - 0.05"
                                                         :max="defaultEntryFloatingValueArr[entry.quality - 1] + 0.05"/>
                                    </el-col>
                                </el-row>
                            </el-form-item>
                        </el-form>
                    </el-form-item>
                </el-form>

                <div slot="footer" class="dialog-footer">
                    <el-button @click="closeEmblemDetailLog()">关闭编辑</el-button>
                </div>
            </el-dialog>

            <el-card v-if="currentRound">
                <div slot="header" class="clearfix">
                    <span>神灵</span>
                </div>
                <el-form class="edit-form" label-suffix=":">
                    <el-form-item label="神灵">
                        <el-checkbox-group v-model="currentRound.godIds" :max="addGodLen"
                                           @change="godIdChange(currentRound.godIds)">
                            <el-checkbox v-for="item in godConfigs" :key="item.id" :label="item.id">
                                <el-image style="width: 35px; height: 50px; float: left"
                                          :src="'./static/god_battle_icon/god_battle_icon_'+ item.id +'.png'"
                                          fit="cover">
                                    <div slot="error" class="image-slot">
                                        <el-image style="width: 35px; height: 50px; float: left"
                                                  :src="'./static/item_icon/0.png'"
                                                  fit="cover">
                                        </el-image>
                                    </div>
                                </el-image>
                                {{ $t(item.name) }}
                            </el-checkbox>
                        </el-checkbox-group>
                    </el-form-item>

                    <el-row>
                        <el-col :span="8" v-for="(item,index) in currentRound.godIds" :key="item">
                            <el-form-item :label="$t(godConfigMap[item].name) +'阶'">

                                <el-input-number v-model.number="currentRound.editGodLv[item]" :min="0"
                                                 :max="12"/>
                            </el-form-item>
                        </el-col>
                    </el-row>
                </el-form>
            </el-card>

<!--            <el-card v-if="currentRound">
                <div slot="header" class="clearfix">
                    <span>世界回响等级</span>
                </div>
                <el-input-number v-model.number="currentRound.resoundLevel" :min="0"/>
            </el-card>-->

            <el-card v-if="currentRound">
                <div slot="header" class="clearfix">
                    <span>神灵契约</span>
                </div>
                <el-form class="edit-form" label-suffix=":">
                    <el-form-item label="层数">
                        <el-input-number v-model="currentRound.editGodContractIdentifiersLen"
                                         @change="onContractCountChange"
                                         :min="0" :max="6"/>
                    </el-form-item>
                    <el-row>
                        <el-col :span="12"
                                v-for="(identifier,stage) in currentRound.editGodContract.identifiers"
                                :key="stage">
                            <el-form-item :label="'第' + (stage +1) + '层'" :key="stage">
                                <el-select v-model="currentRound.editGodContract.identifiers[stage]"
                                           placeholder='请选择'>
                                    <template v-for="(config, idx)  in godContractConfig">
                                        <el-option v-if="idx >= (stage + 1) * 3 - 3 && idx < (stage + 1) * 3"
                                                   :key="config.id"
                                                   :label="$t(config.name) +'-'+ $t(config.description)"
                                                   :value="config.id">
                                        </el-option>
                                    </template>
                                </el-select>
                                <span>等级: </span>
                                <el-input-number v-model.number="currentRound.editGodContract.floorLv[stage]"
                                                 class="number-spacing" :key="stage" :min="0" :max="10"/>
                            </el-form-item>
                        </el-col>
                    </el-row>
                </el-form>
            </el-card>

            <el-card v-if="currentRound">
                <div slot="header" class="clearfix">
                    <span>战墙增益</span>
                </div>
                <el-form class="edit-form" label-suffix=":">
                    <el-form-item label="加固次数">
                        <el-input-number v-model="currentRound.editWarWalls.reinforced" :min="0"/>
                    </el-form-item>

                    <el-form-item label="战墙方向">
                        <el-switch v-model="currentRound.isOwnWall" active-text="已方"
                                   inactive-text="敌方"></el-switch>
                    </el-form-item>
                    <el-form-item label="大战纹">
                        <el-checkbox-group v-model="currentRound.ownWallIds"
                                           v-if="currentRound.isOwnWall == true">
                            <el-checkbox v-for="item in wallGrooveConfig" :key="item.id" v-if="item.type == 1"
                                         :label="item.id">
                                {{ $t(item.name) }}
                            </el-checkbox>
                        </el-checkbox-group>
                        <el-checkbox-group v-model="currentRound.oppWallIds"
                                           v-if="currentRound.isOwnWall ==false">
                            <el-checkbox v-for="item in wallGrooveConfig" :key="item.id" v-if="item.type == 2"
                                         :label="item.id">
                                {{ $t(item.name) }}
                            </el-checkbox>
                        </el-checkbox-group>
                    </el-form-item>
                    <el-form-item label="普通战纹">
                        <el-input-number v-model="currentRound.normalWallCount" :min="0" :max="32"/>
                        <el-button @click="configNormal">配置普通战纹</el-button>
                    </el-form-item>
                    <el-row>
                        <el-col :span="12" v-for="(mark,index) in currentRound.editWarWalls.marks" :key="index">
                            <el-form-item :key="index">
                                <span>战纹{{ index + 1 }}：</span>
                                <el-select v-model="mark.identifier" placeholder='请选择'>
                                    <el-option v-for="item in wallGrooveConfig" :key="item.id"
                                               :label="$t(item.name)"
                                               :value="item.id"
                                               v-if="currentRound.isOwnWall === true?(item.type == 3):(item.type == 4)">
                                    </el-option>
                                </el-select>
                                <span>品质：</span>
                                <el-select v-model="mark.quality" placeholder='请选择'>
                                    <el-option v-for="item in wallGainQuality" :key="item.id"
                                               :label="$t(item.val)"
                                               :value="item.id">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                    </el-row>
                </el-form>
            </el-card>

<!--            <el-card v-if="currentRound">
                <div slot="header" class="clearfix">
                    <span>起源石增益</span>
                </div>

                <el-form class="edit-form">
                    <el-row>
                        <el-col :span="12" v-for="item in originFootingStoneConfig" :key="item.id">
                            <div>{{ $t(item.gain_base_desc) }}</div>
                            <el-form-item :key="item.id" :label="'增益提升 :'">
                                <el-input-number v-model.number="currentRound.ofsGain[item.id]" :min="1"/>
                            </el-form-item>
                        </el-col>
                    </el-row>
                </el-form>
            </el-card>-->

<!--            <el-card v-if="currentRound">
                <div slot="header" class="clearfix">
                    <span>黑暗森林增益</span>
                </div>
                <el-form class="edit-form" label-position="left" :inline="true" label-suffix=":">
                    <el-row>
                        <el-col :span="8" v-for="item in darkForestAbilityConfig" :key="item.id">
                            <div>{{ $t(item.name) }}</div>
                            <el-form-item :key="item.id" :label="$t(item.description)">
                                <blockquote v-if="item.max_lv == 0">
                                    <el-input-number v-model.number="currentRound.dfGain[item.id]" :min="0"/>
                                </blockquote>
                                <blockquote v-else>
                                    <el-input-number v-model.number="currentRound.dfGain[item.id]" :min="0"
                                                     :max="item.max_lv"/>
                                </blockquote>
                            </el-form-item>
                        </el-col>
                    </el-row>
                </el-form>
            </el-card>-->
        </div>
    </el-card>
</template>

<script>
    import commonApi from '../../service/common_api'
    import actionConfirm from '../../mixins/action_confirm'
    import warGrooveQualityJson from '../../data/config/war_groove_quality.json'
    import godSequenceTimeJson from '../../data/config/god_sequence_time.json'
    import bounseJson from '../../data/config/bounse.json'
    import plrzAbilityQualityJson from '../../data/config/plrz_ability_quality.json'
    import {mapState} from 'vuex';

    export default {
        name: "ancient_level_editor",
        data() {
            return {
                plrzAbilityQuality: plrzAbilityQualityJson,
                wallGainQuality: warGrooveQualityJson,
                godSequenceTime: godSequenceTimeJson,
                bonuses: bounseJson,
                oneClickGenSmall: null,
                oneClickGenBig: null,
                addGodLen: 7,

                editorAncientCampaign: true,
                ancientCampaignLineup: {},
                ancientCampaignData: '',

                //动态配置数据
                monsterConfigs: [],
                monsterTemperamentConfigs: [],
                wallGrooveConfig: [],
                wallGrooveConfigMap: {},
                darkForestAbilityConfig: [],
                originFootingStoneConfig: [],
                strengthens: [],
                bigStrengthens: [],
                godContractConfig: [],
                warWallConfiguration: {},
                godConfigs: [],
                godConfigMap: {},
                glyphType: [],
                glyphEntryType: [],
                glyphFateType: [],
                skinGainType: [],
                defaultEntryFloatingValueArr: [0.55, 0.65, 0.75, 0.85, 0.95, 1.05],
                showLineupDetail: false,
                monsterConfiguration: {
                    201: "",
                    202: "",
                },
                plrzRange: ["6"],
                maxPlrz: 0,
                minPlrz: 0,
                // [{回合}, ...], ...
                // 同1个关卡节点可能会有多个关卡，同1个关卡可能会有多回合
                levels: [],
                currentLevelIdx: null,
                currentRoundIdx: null,
                currentRound: null,
                lineup: "",
                previewDateShow: false,
                currentMonsterIdx: null,
                currentMonsterConfig: null,
                previewEmblemDateShow: false,
                emblemMode: 'monster',
                editMonster: {},

                currentEmblemIdx: null,
                editEmblem: {},

                // 阵容战力
                lineupNum: 0,
                monsterSum: 0,
                wallSum: 0,
                contractLvSum: 0,
                godLvSum: 0,
                monsterBattles: [],
                monsterBattleEVOS: []
            }
        },
        mixins: [actionConfirm],
        mounted() {
            this.initData();
        },
        created() {
            // this.initData();
            this.modeChange();
        },
        computed: {
            ...mapState({
                token: state => state.user.userInfo.loginToken,
            }),
        },
        methods: {
            /**
             * 初始化数据
             * 回调动态配置数据
             */
            initData() {
                let self = this;
                let tables = 'immutable_monster_config,immutable_monster_temperament_config,monster_configuration,' +
                    'immutable_parameter_strengthen,immutable_monster_polarity_config,' +
                    'immutable_emblem_effect_config,immutable_god_config,immutable_god_contract_config,' +
                    'origin_footing_stone_config,immutable_dark_forest_ability_config,' +
                    'immutable_war_groove_config,skin_config,war_wall_configuration';
                commonApi.getConfs({
                    tables: tables
                }).then(res => {
                    self.monsterConfigs = res.immutable_monster_config;
                    self.monsterTemperamentConfigs = res.immutable_monster_temperament_config;
                    self.strengthens = [];
                    self.bigStrengthens = [];
                    for (let sg of res.immutable_parameter_strengthen) {
                        if (sg.type === 1) {
                            self.strengthens.push(sg);
                        } else {
                            self.bigStrengthens.push(sg);
                        }
                    }
                    self.plrzAbilities = res.immutable_monster_polarity_config;
                    self.godConfigs = res.immutable_god_config;
                    self.godConfigMap = {};
                    res.immutable_god_config.forEach(function (item) {
                        self.godConfigMap[item.id] = item;
                    })

                    self.wallGrooveConfig = res.immutable_war_groove_config;
                    let wallGrooveConfigMap = {};
                    self.wallGrooveConfig.forEach(item => {
                        wallGrooveConfigMap[item.id] = item;
                    })
                    self.wallGrooveConfigMap = wallGrooveConfigMap;

                    self.darkForestAbilityConfig = res.immutable_dark_forest_ability_config;
                    self.godContractConfig = res.immutable_god_contract_config;
                    self.originFootingStoneConfig = res.origin_footing_stone_config;
                    self.warWallConfiguration = res.war_wall_configuration;
                    self.skinGainType = res.skin_config;
                    self.skinGainType.unshift({
                        id: 0
                    });
                    self.warWallConfiguration = {};
                    for (let wwc of res.war_wall_configuration) {
                        let id = wwc.id,
                            val = wwc.key_value;
                        self.warWallConfiguration[id] = val;
                    }


                    self.monsterConfiguration = {};
                    for (let mc of res.monster_configuration) {
                        let id = mc.id;
                        let val = mc.key_value;
                        self.monsterConfiguration[id] = val;
                        if (id === 701) {
                            let splitValArr = val.split(',');
                            self.minPlrz = parseFloat(splitValArr[0]);
                            self.maxPlrz = parseFloat(splitValArr[1]);
                        } else if (id === 702) {
                            self.plrzRange = val.split(',');
                        }
                    }

                    self.glyphType = [{
                        id: 0,
                        name: '无',
                        description: '无元核'
                    }];
                    self.glyphEntryType = [];
                    self.glyphFateType = [{
                        id: 0,
                        name: '无',
                        description: '无效果'
                    }];

                    res.immutable_emblem_effect_config.forEach(function (item) {
                        let type = item.type;
                        if (type == 0) {
                            self.glyphType.push(item);
                        } else if (type == 1 || type == 2) {
                            self.glyphEntryType.push(item);
                        } else {
                            self.glyphFateType.push(item);
                        }
                    });

                    this.addLevel();
                })
            },
            /**
             * 查询阵容战力
             */
            getCalcLineUp() {
                var data = this.currentRound;
                let lineupData = this.generateLineup(data);
                commonApi.lineupCalculator({
                    token: this.token,
                    lineupVO: lineupData
                }).then(res => {
                    this.lineupNum = res.total;
                    this.monsterBattles = res.monsterBattles;
                    this.monsterBattleEVOS = res.monsterBattleEVOS;
                    this.monsterSum = res.monsterSum;
                    this.wallSum = res.wallSum;
                    this.contractLvSum = res.contractLvSum;
                    this.godLvSum = res.godLvSum;
                })
            },

            /**
             * @param {Object} itemId
             * @param {Object} plrzAbilitiesMap
             */
            handlePlrzAbility(itemId, plrzAbilitiesMap) {
                let currentArr = [];
                for (let plrzItem of plrzAbilitiesMap) {
                    currentArr.push(plrzItem.identifier);
                }

                return currentArr.indexOf(itemId) > -1;
            },

            handlerMonsterChange(editMonster) {
                this.handlerMonsterIdentifierSkin(editMonster);
                let abSize = this.currentMonsterConfig.abilities.split(",").length;
                let ab = {};
                for (let i = 0; i < abSize; i++) {
                    ab[i + 1] = 1;
                }
                editMonster.abilityStarMap = ab;
            },
            /**
             *
             */
            handlerMonsterIdentifierSkin(editMonster) {
                if (editMonster === undefined || editMonster.skinId === undefined) {
                    return;
                }
                let oldType = 0;
                let currentTypeMap = {};
                if (editMonster.skinId > 0) {
                    for (let sgt of this.skinGainType) {
                        if (sgt.id === editMonster.skinId) {
                            oldType = sgt.type;
                        }
                        if (sgt.monster_identifier === editMonster.identifier) {
                            currentTypeMap[sgt.type] = sgt.id;
                        }
                    }

                    editMonster.skinId = 0;
                    if (currentTypeMap[oldType] !== undefined) {
                        editMonster.skinId = currentTypeMap[oldType];
                    }
                }

                for (let monsterConfigItem of this.monsterConfigs) {
                    if (monsterConfigItem.id === editMonster.identifier) {
                        this.currentMonsterConfig = monsterConfigItem;
                    }
                }


                return editMonster.skinId;
            },
            /**
             * 一键基因处理
             * @param {Object} genType
             * @param {Object} editMonster
             */
            oneClickGen(genType, editMonster) {
                let self = this;
                let rateConfig = parseInt(self.monsterConfiguration[202]);
                if ((genType === 'big' && self.oneClickGenBig == null)) {
                } else if ((genType === 'small' && self.oneClickGenSmall == null)) {
                } else {
                    if (editMonster.strengthenCount > 0) {
                        let newGenArr = [];
                        for (let idx = 0; idx < editMonster.strengthenCount; idx++) {
                            let smallFlag = (idx + 1) % rateConfig !== 0;
                            if (genType === 'small' && smallFlag) {
                                newGenArr.push(self.oneClickGenSmall);
                            } else if (genType === 'big' && !smallFlag) {

                                newGenArr.push(self.oneClickGenBig);
                            } else {
                                newGenArr.push(editMonster.strengthenList[idx]);
                            }
                        }

                        editMonster.strengthenList = newGenArr;
                    }
                }
            },
            /**
             * 元核宿命效果调整
             * @param {Object} emblemIn
             */
            changeFateType(emblemIn) {
                if (emblemIn.fateType && emblemIn.fateType !== 0 && emblemIn.quality > 0) {
                    emblemIn.fateFloatingValue = this.defaultEntryFloatingValueArr[emblemIn.quality - 1];
                } else {
                    emblemIn.fateFloatingValue = 0;
                }
            },

            /**
             *设置默认浮动值
             * @param {Object} entry
             */
            defaultEntryFloatingValue(entry) {
                entry.floatingValue = this.defaultEntryFloatingValueArr[entry.quality - 1];
            },

            /**
             * 元核对象初始化
             */
            initEmblem() {
                return {
                    level: 1,
                    stage: 0,
                    quality: 1,
                    identifier: 50001,
                    identified: true,
                    entries: [],
                    baseType: 0,
                    fateType: 0,
                    fateFloatingValue: 0.0,
                    editGlyphEntriesLen: 1
                };
            },
            /**
             * 怪兽对象初始化
             */
            initMonster() {
                let monsterInit = {
                    identifier: null,
                    temperamentId: 15,
                    level: 1,
                    strengthenCount: 0,
                    strengthenList: [],
                    abilityStarMap: {
                        1: 0,
                        2: 0,
                        3: 0,
                        4: 0,
                        5: 0
                    },
                    plrzAtk: 0,
                    plrzCon: 0,
                    plrzHaki: 0,
                    plrzMspd: 0,
                    plrzAbilitiesMap: [],
                    bonus: [],
                    skinId: 0,

                    //不保存的数据字段
                    editMonsterPlrzAbilitiesLen: 0,
                    editMonsterBonusLen: 0
                };
                if (!this.editorAncientCampaign) {
                    monsterInit.emblemIn = this.initEmblem();
                }
                return monsterInit;
            },
            /**
             * 怪兽编辑
             **/
            editMonsterFn(idx) {
                this.currentMonsterIdx = idx;
                this.editMonster = this.currentRound.monsters[idx];
                this.handlerMonsterIdentifierSkin(this.editMonster);
                this.previewDateShow = true;
            },
            /**
             * 关闭怪兽编辑框
             **/
            closeDetailLog() {
                this.currentRound.monsters[this.currentMonsterIdx] = this.editMonster;
                this.previewDateShow = false;
            },
            deleteMonster(idx) {
                this.currentRound.monsters.splice(idx, 1, this.initMonster());
            },

            editEmblemFn(idx, emblemMode) {
                if (emblemMode === 'emblem') {
                    this.currentEmblemIdx = idx;

                    this.editEmblem = this.currentRound.editEmblems[idx];
                } else {
                    let currentMonster = this.currentRound.monsters[this.currentMonsterIdx];
                    this.editEmblem = currentMonster.emblemIn;
                }

                this.previewEmblemDateShow = true;
                this.emblemMode = emblemMode;
            },
            deleteEmblem(idx) {
                this.currentRound.editEmblems.splice(idx, 1, this.initEmblem());
            },
            closeEmblemDetailLog() {
                if (this.emblemMode === 'emblem') {
                    this.currentRound.editEmblems[this.currentEmblemIdx] = this.editEmblem;
                } else {
                    let currentMonster = this.currentRound.monsters[this.currentMonsterIdx];
                    currentMonster.emblemIn = this.editEmblem;
                    //this.currentRound.monsters[this.currentMonsterIdx] = currentMonster;
                }

                this.previewEmblemDateShow = false;
            },


            /**
             * 添加子关卡
             */
            addLevel() {
                let levels = this.levels;
                levels.push([]);
                this.currentLevelIdx = levels.length - 1;
                this.addRound();
            },
            /**
             * 选择子关卡
             * @param idx 下标
             */
            selectLevel(idx) {
                this.currentLevelIdx = idx;
                this.selectRound(0);
            },
            /**
             * 获取子关卡名称，罗马数字
             * @param idx 下标
             * @returns {string} 关卡名称
             */
            getLevelName(idx) {
                let data = {
                    'ↈ': 100000,
                    'ↂↈ': 90000,
                    'ↇ': 50000,
                    'ↂↇ': 40000,
                    'ↂ': 10000,
                    'Ⅿↂ': 9000,
                    'ↁ': 5000,
                    'Ⅿↁ': 4000,
                    'Ⅿ': 1000,
                    'ⅭⅯ': 900,
                    'Ⅾ': 500,
                    'ⅭⅮ': 400,
                    'Ⅽ': 100,
                    'ⅩⅭ': 90,
                    'Ⅼ': 50,
                    'ⅩⅬ': 40,
                    'Ⅹ': 10,
                    'Ⅸ': 9,
                    'Ⅷ': 8,
                    'Ⅶ': 7,
                    'Ⅵ': 6,
                    'Ⅴ': 5,
                    'Ⅳ': 4,
                    'Ⅲ': 3,
                    'Ⅱ': 2,
                    'Ⅰ': 1
                };
                let num = idx + 1;
                let roman = '';
                for (let i in data) {
                    while (num >= data[i]) {
                        roman += i;
                        num -= data[i];
                    }
                }
                return roman;
            },
            onCopy(e) {
                this.$message({
                    type: 'success',
                    message: '已复制至系统粘贴板'
                });
            },
            onError(e) {
                this.$message({
                    type: 'error',
                    message: '复制失败,请手动复制'
                });
            },
            /**
             * 删除子关卡
             */
            deleteLevel() {
                let levels = this.levels;
                let len = levels.length;
                if (len > 1) {
                    let idx = this.currentLevelIdx;
                    levels.splice(idx, 1);
                    this.selectLevel(idx >= len - 1 ? len - 2 : idx);
                }
            },

            /**
             * 添加回合
             */
            addRound() {
                let self = this;
                let rounds = this.levels[this.currentLevelIdx];
                let lineup = {
                    gods: [],
                    monsters: [
                        self.initMonster(),
                        self.initMonster(),
                        self.initMonster(),
                        self.initMonster(),
                        self.initMonster()
                    ],

                    //战墙
                    normalWallCount: 0,
                    isOwnWall: true,
                    ownWallIds: [],
                    oppWallIds: [],
                    editWarWalls: {
                        reinforced: 0,
                        marks: []
                    },
                    resoundLevel: 0,

                    //黑暗森林
                    dfGain: [],

                    //起源基石
                    ofsGain: [],

                    //神灵契约
                    editGodContractIdentifiersLen: 0,
                    editGodContract: {
                        identifiers: [],
                        floorLv: [0, 0, 0, 0, 0, 0],
                    },

                    //神灵
                    godIds: [],
                    editGodLv: [],
                    editGodSeq: [],
                    editGodCast: [],
                    editEmblems: []
                };
                rounds.push(lineup);
                /* for (let key in lineup) {
                    this[key] = lineup[key];
                } */
                this.selectRound(rounds.length - 1);
            },
            /**
             * 选择回合
             * @param idx 下标
             */
            selectRound(idx) {
                this.currentRoundIdx = idx;
                this.currentRound = this.levels[this.currentLevelIdx][idx];
            },
            /**
             * 删除回合
             */
            deleteRound() {
                let rounds = this.levels[this.currentLevelIdx];
                let len = rounds.length;
                if (len > 1) {
                    let idx = this.currentRoundIdx;
                    rounds.splice(idx, 1);
                    this.selectRound(idx >= len - 1 ? len - 2 : idx);
                }
            },
            /**
             * 四舍五入，可指定要保留的小数位
             * @param number 数字
             * @param decimalPlaces 要保留的小数位，默认不保留
             * @returns {number} 四舍五入后的数字
             */
            round(number, decimalPlaces = 0) {
                return Math.round(number * Math.pow(10, decimalPlaces)) / Math.pow(10, decimalPlaces);
            },
            /**
             * 配置普通战纹
             *
             */
            configNormal() {
                let marks = [];
                for (let i = 0; i < this.currentRound.normalWallCount; i++) {
                    marks.push({
                        identifier: null,
                        quality: 0
                    });
                }
                this.currentRound.editWarWalls.marks = marks;
            },
            /**
             * 神灵契约
             * @param e
             */
            onContractCountChange(e) {
                let editGodContract = this.currentRound.editGodContract;
                let identifiers = editGodContract.identifiers;
                let sub = this.currentRound.editGodContractIdentifiersLen - identifiers.length;
                if (sub > 0) {
                    for (let i = 0; i < sub; i++) {
                        identifiers.push(3 * identifiers.length + 1);
                    }
                } else {
                    for (let i = 0; i < -sub; i++) {
                        identifiers.splice(identifiers.length - 1, 1);
                    }
                }
                for (let i = 0; i < 6; i++) {
                    if (i < this.currentRound.editGodContractIdentifiersLen) {
                        if (editGodContract.floorLv[i] < 1) {
                            editGodContract.floorLv[i] = 1;
                        }
                    } else {
                        editGodContract.floorLv[i] = 0;
                    }
                }
            },

            /**
             * 获取皮肤名
             */
            getSkinName(sgt) {
                if (sgt.id === 0) {
                    return '无';
                }
                let names = ['邪能', '魔法', '机械', '美食', '制服', '玩具', '大和', '黄金', '冰川', '熔岩', '龙', '源力',
                    '部落', '世界杯', '深海'
                ];
                return names[sgt.type];
            },
            /**
             * 获取强化名
             */
            getStrengthenName(item) {
                let des = this.$t(item.description);
                return des.replace('{p1}', item.p1).replace('{p2}', item.p2);
            },
            /**
             * 其他减益
             * @param {Object} editMonster 当前编辑的怪兽
             */
            onBonusCountChange(editMonster) {
                let bonus = editMonster.bonus;
                let sub = editMonster.editMonsterBonusLen - bonus.length;
                if (sub > 0) {
                    for (let i = 0; i < sub; i++) {
                        bonus.push({
                            key: 'atkConstant',
                            value: 0
                        });
                    }
                } else {
                    for (let i = 0; i < -sub; i++) {
                        bonus.splice(bonus.length - 1, 1);
                    }
                }
            },
            /**
             * 极化技能条处理
             * @param {Object} editMonster 当前编辑的怪兽
             */
            onPlrzCountChange(editMonster) {
                let plrzAbilities = editMonster.plrzAbilitiesMap;
                let sub = editMonster.editMonsterPlrzAbilitiesLen - plrzAbilities.length;
                if (editMonster.editMonsterPlrzAbilitiesLen > 0 && editMonster.editMonsterPlrzAbilitiesLen < 4) {
                    editMonster.editMonsterPlrzAbilitiesLen = sub < 0 ? 0 : 4;
                    sub = editMonster.editMonsterPlrzAbilitiesLen - plrzAbilities.length;
                }
                if (sub > 0) {
                    for (let i = 0; i < sub; i++) {
                        plrzAbilities.push({
                            identifier: i + 1,
                            quality: 1
                        });
                    }
                } else {
                    for (let i = 0; i < -sub; i++) {
                        plrzAbilities.splice(plrzAbilities.length - 1, 1);
                    }
                }
            },
            /**
             * 基因强化处理
             * @param {Object} editMonster 当前编辑的怪兽
             */
            onStrengthenCountChange(editMonster) {
                let strengthenList = editMonster.strengthenList;
                let sub = editMonster.strengthenCount - strengthenList.length;
                if (sub > 0) {
                    for (let i = 0; i < sub; i++) {
                        let idx = strengthenList.length + 1;
                        if (idx % parseInt(this.monsterConfiguration[202]) === 0) {
                            strengthenList.push(this.bigStrengthens[0].id);
                        } else {
                            strengthenList.push(this.strengthens[0].id);
                        }
                    }
                } else {
                    for (let i = 0; i < -sub; i++) {
                        strengthenList.splice(strengthenList.length - 1, 1);
                    }
                }
            },

            /**
             * 神灵
             * */
            godIdChange(godIds) {
                godIds.forEach(godId => {
                    let lv = this.currentRound.editGodLv[godId];
                    if (lv === undefined) {
                        this.currentRound.editGodLv[godId] = 0;
                    }
                })
            },

            /**
             * 元核效果调整
             * @param {Object} editMonster 当前编辑的元核
             */
            onGlyphEntriesCountChange(editEmblem) {
                let entries = editEmblem.entries;
                editEmblem.editGlyphEntriesLen = editEmblem.quality;
                let sub = editEmblem.editGlyphEntriesLen - entries.length;
                if (sub > 0) {
                    for (let i = 0; i < sub; i++) {
                        entries.push({
                            type: 7,
                            floatingValue: 0
                        });
                    }
                } else {
                    for (let i = 0; i < -sub; i++) {
                        entries.splice(entries.length - 1, 1);
                    }
                }

                this.changeFateType(editEmblem);
            },
            /**
             * 词条数量变化相应的判断
             * @param {Object} editMonster 当前编辑的元核
             */
            glyphEntriesChange(editEmblem) {
                let entries = editEmblem.entries;
                let max = editEmblem.quality;
                if (editEmblem.editGlyphEntriesLen > max) {
                    editEmblem.editGlyphEntriesLen = max;
                }
                let sub = editEmblem.editGlyphEntriesLen - entries.length;
                if (sub > 0) {
                    for (let i = 0; i < sub; i++) {
                        entries.push({
                            type: 7,
                            floatingValue: 0
                        });
                    }
                } else {
                    for (let i = 0; i < -sub; i++) {
                        entries.splice(entries.length - 1, 1);
                    }
                }
            },
            /**
             * 计算进阶次数
             * @param {Object} editEmblem 当前编辑的元核
             */
            onGlyphLevelChange(editEmblem) {
                editEmblem.stage = Math.floor(editEmblem.level / 5);
            },
            calSynchronizeLv(entries) {
                console.log(entries);
                let synchronizeLevel = 0;

                if (entries.length < 3) {
                    return synchronizeLevel;
                }

                let blue = 0;
                let purple = 0;
                let orange = 0;
                let red = 0;

                for (let i = 0; i < entries.length; i++) {
                    let entry = entries[i];
                    let quality = entry.quality;
                    switch (quality) {
                        case 3:
                            blue++;
                            break;
                        case 4:
                            purple++;
                            break;
                        case 5:
                            orange++;
                            break;
                        case 6:
                            red++;
                            break;
                    }
                }

                if (blue + purple + orange + red >= 3) synchronizeLevel = 1;
                if (purple + orange + red >= 4) synchronizeLevel = 2;
                if (orange + red >= 5) synchronizeLevel = 3;
                if (red >= 6) synchronizeLevel = 4;

                return synchronizeLevel;
            },

            generateEmblem(sourceEmblemIn) {
                let baseType = sourceEmblemIn.baseType;
                if (baseType <= 0) {
                    return null;
                }
                let glyphType = this.glyphType;
                let glyphEntryType = this.glyphEntryType;
                let glyphFateType = this.glyphFateType;

                let ratio;
                for (let config of glyphType) {
                    if (baseType === config.id) {
                        ratio = config.strengthen_coefficient;
                    }
                }
                let synchronizeLevel = 0;
                let identifier = 50001;
                let valEntries = sourceEmblemIn.entries;
                let valEntriesL = valEntries.length;
                let level = sourceEmblemIn.level;
                let stage = sourceEmblemIn.stage;
                if (valEntriesL >= 3) {
                    console.log("!");
                    synchronizeLevel = this.calSynchronizeLv(sourceEmblemIn.entries);
                }
                let properties = [{
                    type: 0,
                    effectId: baseType,
                    quality: sourceEmblemIn.quality,
                    rdFloat: 1.0
                }];
                for (let i = 0; i < valEntriesL; i++) {
                    let valEntry = valEntries[i];
                    let effectId = valEntry.type;
                    let quality = valEntry.quality;
                    let type, value, ratio;
                    for (let config of glyphEntryType) {
                        if (config.id === effectId) {
                            type = config.type;
                            value = config.base_value;
                            ratio = config.strengthen_coefficient;
                            break;
                        }
                    }
                    let fv = valEntry.floatingValue;
                    properties.push({
                        type: type,
                        effectId: effectId,
                        rdFloat: fv,
                        quality: quality
                    });
                }
                let emblemIn = {
                    level: level,
                    stage: stage,
                    quality: sourceEmblemIn.quality,
                    properties: properties,
                    identified: true,
                    identifier: identifier,
                    synchronizeLevel: synchronizeLevel
                };
                let fateType = sourceEmblemIn.fateType;
                if (fateType !== 0) {
                    let ratio;
                    for (let config of glyphFateType) {
                        if (fateType === config.id) {
                            ratio = config.strengthen_coefficient;
                        }
                    }
                    let fv = sourceEmblemIn.fateFloatingValue;
                    properties.push({
                        type: 3,
                        effectId: fateType,
                        rdFloat: fv,
                        quality: sourceEmblemIn.quality
                    });
                }
                return emblemIn;
            },
            parseEmblem(sourceEmblem) {
                let emblemTpl = this.initEmblem();
                let emblemIn = {};
                for (let emblemTplKey in emblemTpl) {
                    let sourceTpl = sourceEmblem[emblemTplKey];
                    if (sourceTpl != undefined) {
                        emblemIn[emblemTplKey] = sourceTpl;
                    } else {
                        emblemIn[emblemTplKey] = emblemTpl[emblemTplKey];
                    }
                }

                let entries = [];
                let properties = sourceEmblem.properties;
                for (let property of properties) {
                    let type = property.type;
                    if (type == 0) {
                        emblemIn.baseType = property.effectId;
                    } else if (type == 3) {
                        emblemIn.fateType = property.effectId;
                        emblemIn.fateFloatingValue = property.rdFloat;
                    } else {
                        entries.push({
                            type: property.effectId,
                            quality: property.quality,
                            floatingValue: property.rdFloat
                        });
                    }
                }

                emblemIn.entries = entries;
                emblemIn.editGlyphEntriesLen = emblemIn.entries.length;
                return emblemIn;
            },
            /**
             * 生成单个阵容
             * @param {Object} round
             */
            generateLineup(round) {
                let lineup = {};
                let self = this;

                //怪兽处理
                let skinGains = [];
                let monsters = [];
                let appMonsters = round.monsters;
                for (let i = 0, l = appMonsters.length; i < l; i++) {
                    let appMonster = appMonsters[i];
                    if (null == appMonster.identifier) {
                        monsters.push(null);
                        continue;
                    }

                    let monster = appMonster == null ? null : {};
                    for (let key in appMonster) {
                        if (appMonster.hasOwnProperty(key)) {
                            let val = appMonster[key];
                            switch (key) {
                                case 'emblemIn':
                                    let newEmblemIn = self.generateEmblem(val);
                                    if (newEmblemIn != null) {
                                        monster[key] = newEmblemIn;
                                    }
                                    break;
                                case 'plrzAbilitiesMap':
                                    if (val.length) {
                                        monster[key] = {};
                                        for (let pa of val) {
                                            monster[key][pa.identifier] = pa.quality;
                                        }
                                    }
                                    break;
                                case 'bonus':
                                    let l = val.length;
                                    if (l) {
                                        let bonus = {};
                                        for (let i = 0; i < l; i++) {
                                            let b = val[i];
                                            let key = b.key;
                                            let value = b.value;
                                            if (bonus[key] === undefined) {
                                                bonus[key] = value;
                                            } else {
                                                bonus[key] += value;
                                            }
                                        }
                                        monster[key] = bonus;
                                    }
                                    break;
                                case 'skinId':
                                    if (val !== 0) {
                                        val = self.handlerMonsterIdentifierSkin(appMonster);
                                        skinGains.push(val);
                                    }
                                    monster[key] = val;
                                    break;
                                case 'editMonsterBonusLen':
                                case 'editMonsterPlrzAbilitiesLen':
                                    delete monster[key]
                                    break;
                                default:
                                    monster[key] = val;
                                    break;
                            }
                        }
                    }
                    monsters.push(monster);
                }

                //神灵处理
                let gods = [];
                let appGodIds = round.godIds;
                for (let i = 0, l = appGodIds.length; i < l; i++) {
                    let appGodId = appGodIds[i];
                    if (appGodId === null || appGodId === undefined) {
                        continue;
                    }
                    let god = {
                        identifier: appGodId,
                        level: round.editGodLv[appGodId]
                    }

                    gods.push(god);
                }

                lineup = {
                    gods: gods,
                    monsters: monsters
                };

                //神灵契约
                if (round.editGodContractIdentifiersLen > 0) {
                    lineup.godContract = {
                        identifiers: round.editGodContract.identifiers.join(),
                        floorLv: round.editGodContract.floorLv.join()
                    };
                }

                //释放序列
                let appGodSeq = round.editGodSeq
                let appGodCast = round.editGodCast
                if (appGodSeq.length > 0) {
                    let godSequence = [];

                    for (let i = 0, l = appGodSeq.length; i < l; i++) {
                        let appGodSeqItem = appGodSeq[i];
                        let appGodCastItem = appGodCast[i];
                        if (appGodSeqItem === null || appGodSeqItem === undefined) {
                            continue;
                        }
                        godSequence.push({
                            identifier: appGodSeqItem,
                            cast: appGodCastItem
                        })

                    }

                    lineup.godSequence = godSequence;
                }

                //起源基石
                if (round.ofsGain.length > 0) {
                    let ofsGains = [];
                    let appOfsGain = round.ofsGain;

                    for (let i = 0, l = appOfsGain.length; i < l; i++) {
                        let appOfsGainItem = appOfsGain[i];
                        if (appOfsGainItem == null) {
                            continue;
                        }

                        ofsGains.push({
                            identifier: i,
                            mlp: appOfsGainItem
                        })

                    }
                    lineup.ofsGains = ofsGains;
                }

                //黑暗森林
                if (round.dfGain.length > 0) {
                    let dfGains = [];
                    let appDfGain = round.dfGain;

                    for (let i = 0, l = appDfGain.length; i < l; i++) {
                        let appDfGainItem = appDfGain[i];
                        if (appDfGainItem == null) {
                            continue;
                        }

                        dfGains.push({
                            identifier: i,
                            level: appDfGainItem
                        })

                    }
                    lineup.dfGains = dfGains;
                }

                //皮肤
                if (skinGains.length) {
                    lineup.skinGains = skinGains;
                }

                //战墙
                let warWalls = {
                    reinforced: 0,
                    marks: []
                };
                let setWallFlag = false;
                if (round.editWarWalls) {
                    warWalls.reinforced = round.editWarWalls.reinforced;
                    setWallFlag = true;
                }
                if (round.normalWallCount > 0 ||
                    round.oppWallIds.length > 0 ||
                    round.ownWallIds.length > 0) {
                    setWallFlag = true;
                    let marks = [];

                    //大战纹
                    let wallIds;
                    if (round.isOwnWall) {
                        wallIds = round.ownWallIds;
                    } else {
                        wallIds = round.oppWallIds;
                    }

                    for (let i = 0, l = wallIds.length; i < l; i++) {
                        let wallId = wallIds[i];
                        if (wallId == null) {
                            continue;
                        }
                        marks.push({
                            identifier: wallId,
                            quality: 0
                        })
                    }

                    //小战纹
                    for (let i = 0, l = round.editWarWalls.marks.length; i < l; i++) {
                        let mark = round.editWarWalls.marks[i];
                        if (mark == null) {
                            continue;
                        }
                        marks.push(mark)
                    }
                    warWalls.marks = marks;
                }
                if (setWallFlag) {
                    lineup.warWalls = warWalls;
                }
                if (!round.resoundLevel) {
                    lineup.resoundLevel = 0;
                }
                return lineup;
            },

            parseLineup(round) {
                let self = this;

                let monsters = round.monsters;
                let mons = [];
                //怪兽
                for (let monster of monsters) {
                    let mon;
                    let monsterTpl = this.initMonster();

                    if (monster === null) {
                        mon = self.initMonster();
                    } else {
                        mon = {};
                        for (let key in monsterTpl) {
                            if (monster[key] !== undefined) {
                                let val = monster[key];
                                switch (key) {
                                    case 'emblemIn':
                                        mon[key] = self.parseEmblem(val);
                                        break;
                                    case 'plrzAbilitiesMap':
                                        let abilities = [];
                                        for (let aKey in val) {
                                            abilities.push({
                                                identifier: parseInt(aKey),
                                                quality: parseInt(val[aKey])
                                            });
                                        }
                                        mon[key] = abilities;
                                        break;
                                    case 'bonus':
                                        let bonus = [];
                                        for (let bonusKey in val) {
                                            bonus.push({
                                                key: bonusKey,
                                                value: val[bonusKey]
                                            });
                                        }
                                        mon[key] = bonus;
                                        break;
                                    default:
                                        mon[key] = monster[key];
                                        break;
                                }
                            } else {
                                //let a = monsterTpl[key];

                                mon[key] = monsterTpl[key];
                            }
                        }
                    }
                    mon.editMonsterBonusLen = mon.bonus.length;
                    mon.editMonsterPlrzAbilitiesLen = mon.plrzAbilitiesMap.length;
                    mons.push(mon);
                }
                round.monsters = mons;

                //神灵
                let gods = round.gods;
                let godIds = [];
                let editGodLv = [];
                if (gods && gods.length > 0) {
                    gods.forEach(god => {
                        godIds.push(god.identifier);
                        editGodLv[god.identifier] = god.level;
                    })
                }
                round.godIds = godIds;
                round.editGodLv = editGodLv;


                //神灵释放序列
                let seq = round.godSequence
                let editGodSeq = [];
                let editGodCast = [];

                if (seq && seq.length > 0) {
                    for (let i = 0, l = seq.length; i < l; i++) {
                        let seqItem = seq[i];
                        if (seqItem === null || seqItem === undefined) {
                            continue;
                        }
                        editGodSeq.push(seqItem.identifier);
                        editGodCast.push(seqItem.cast);
                    }
                }
                round.editGodSeq = editGodSeq;
                round.editGodCast = editGodCast;


                //神灵契约
                let godContract = round.godContract;
                let editGodContract = {
                    identifiers: [],
                    floorLv: [0, 0, 0, 0, 0, 0]
                };
                editGodContract.identifiers = [];
                editGodContract.floorLv = [];
                if (godContract) {
                    godContract.identifiers.split(",").forEach(identifierItem => {
                        if (identifierItem !== null && identifierItem !== undefined) {
                            editGodContract.identifiers.push(identifierItem >> 0);
                        }

                    });


                    let seqFloorLvArr = godContract.floorLv.split(",");

                    for (let i = 0, l = seqFloorLvArr.length; i < l; i++) {
                        let itemFloorLv = seqFloorLvArr[i];
                        if (itemFloorLv !== null && itemFloorLv !== undefined) {
                            editGodContract.floorLv[i] = itemFloorLv >> 0;
                        }
                    }
                }

                round.editGodContract = editGodContract;
                round.editGodContractIdentifiersLen = editGodContract.identifiers.length;

                //黑暗森林
                let dfGains = round.dfGains;
                let dfGain = [];
                if (dfGains && dfGains.length > 0) {
                    for (let i = 0, l = dfGains.length; i < l; i++) {
                        let dfGainsItem = dfGains[i];
                        let ofsIdentifier = dfGainsItem.identifier >> 0;
                        let ofsLv = dfGainsItem.level >> 0;
                        dfGain[ofsIdentifier] = ofsLv;
                    }
                }
                round.dfGain = dfGain;

                //战墙
                let warWalls = round.warWalls;
                let normalWallCount = 0;
                let isOwnWall = true;
                let ownWallIds = [];
                let oppWallIds = [];
                let editWarWalls = {
                    reinforced: 0,
                    marks: []
                };

                if (warWalls) {
                    editWarWalls.reinforced = warWalls.reinforced >> 0;
                    let warGrooveMap = this.wallGrooveConfigMap;
                    let marks = [];
                    for (let i = 0, l = warWalls.marks.length; i < l; i++) {
                        let mark = warWalls.marks[i];
                        let markIdentifier = mark.identifier >> 0;
                        let markQuality = mark.quality >> 0;
                        let warGrooveConfig = warGrooveMap[markIdentifier];
                        let warGrooveConfigType = warGrooveConfig.type;
                        if (warGrooveConfigType == 1) {
                            ownWallIds.push(markIdentifier);
                        } else if (warGrooveConfigType == 2) {
                            isOwnWall = false;
                            oppWallIds.push(markIdentifier);
                        } else {
                            normalWallCount++;
                            marks.push({
                                identifier: markIdentifier,
                                quality: markQuality
                            });
                        }
                    }
                    editWarWalls.marks = marks;
                }

                round.normalWallCount = normalWallCount;
                round.isOwnWall = isOwnWall;
                round.ownWallIds = ownWallIds;
                round.oppWallIds = oppWallIds;
                round.editWarWalls = editWarWalls;


                //起源基石
                let ofsGains = round.ofsGains;
                let ofsGain = [];
                if (ofsGains && ofsGains.length > 0) {
                    for (let i = 0, l = ofsGains.length; i < l; i++) {
                        let ofsGainItem = ofsGains[i];
                        ofsGain[ofsGainItem.identifier] = ofsGainItem.mlp;
                    }
                }
                round.ofsGain = ofsGain;
                console.log("resoundLevel", round.resoundLevel)
                if (round.resoundLevel === undefined) {
                    round.resoundLevel = 0;
                }

                if (round.editEmblems !== undefined) {
                    let newEmblems = [];
                    round.editEmblems.forEach(editEmblem => {
                        newEmblems.push(self.parseEmblem(editEmblem));
                    })
                    round.editEmblems = newEmblems;
                }

                return round;
            },

            /**
             * 古记战役数据生成
             */
            generateAncientCampaignData() {
                let self = this;
                let result = {
                    emblems: [],
                    gods: [],
                    lineup: {},
                    monsters: []
                };
                let lineup = self.generateLineup(this.currentRound);
                let monsters = lineup.monsters;
                let remainMonsters = [];

                let lineupMonsters = [];
                let lineupMonstersCount = 0;
                let id = -1;
                for (let monsterItem of monsters) {
                    if (null != monsterItem){
                        id++;
                        monsterItem.id = id;
                    }
                    if (lineupMonstersCount < 5) {
                        lineupMonsters.push(monsterItem);
                        lineupMonstersCount++;
                    } else {
                        if (null != monsterItem) {
                            remainMonsters.push(monsterItem);
                        }
                    }
                }
                while (lineupMonsters.length < 5) {
                    lineupMonsters.push(null);
                }
                lineup.monsters = lineupMonsters;

                let emblems = [];
                this.currentRound.editEmblems.forEach(editEmblem => {
                    if(null !== editEmblem){
                        emblems.push(self.generateEmblem(editEmblem));
                    }

                })

                result.gods = lineup.gods;
                result.emblems = emblems;

                lineup.gods = [];
                lineup.godSequence = [];
                result.lineup = lineup;
                result.monsters = remainMonsters;

                this.ancientCampaignData = JSON.stringify(result);
            },
            parseAncientCampaignData() {
                let self = this;
                if ("" === this.ancientCampaignData.trim()) {
                    this.$message({
                        type: 'error',
                        message: '古记战役没有数据'
                    });
                    return;
                }
                let tmpData = JSON.parse(this.ancientCampaignData);
                let round = tmpData.lineup;
                if (round !== undefined) {
                    if (tmpData.monsters.length > 0){
                        for (let roundElement of tmpData.monsters) {
                            round.monsters.push(roundElement)
                        }
                    }
                    round.gods = tmpData.gods;
                    round.editEmblems = tmpData.emblems;
                    self.parseLineup(round);
                    self.currentRound = round;
                } else if (round == undefined) {
                    let lineup = JSON.parse(this.ancientCampaignData);
                    let levels = lineup.levels;
                    levels.forEach(rounds => {
                        rounds.forEach(roundItem => {
                            self.parseLineup(roundItem);
                        })
                    })

                    self.levels = levels;
                    if (levels.length) {
                        self.selectRound(0);
                        self.getCalcLineUp();
                    }
                }
            },


            modeChange() {
                let self = this;
                if (self.editorAncientCampaign === true) {
                    //古记战役模式
                    self.levels = [];
                    self.addLevel();
                    // self.addGodLen = self.godConfigs.length;
                }
            },
            ancientCampaignAddEmblem() {
                let self = this;
                self.currentRound.editEmblems.push(self.initEmblem())
            },
            ancientCampaignAddMonster() {
                let self = this;
                self.currentRound.monsters.push(self.initMonster())
            }
        }
    };
</script>

<style lang="less">
    .box-card {

        .tip {
            margin: 10px 0;
            color: red;
            font-weight: bold;
            font-size: 12px;
            font-style: italic;
        }

        .spacing {
            margin-bottom: 5px;
        }

        .number-spacing {
            margin-bottom: 10px;
        }

        .circle-spacing {
            margin: 10px 0;
        }

        .edit-form {
            padding: 5px 10px;
            background-color: #f4f4f5;
            margin-bottom: 10px;
            border: 1px solid #d3d4d6;
            border-radius: 3px;
        }

        .del-btn {
            display: block;
        }

        .battleE-col {
            margin-left: 80px;
        }
    }
</style>



// WEBPACK FOOTER //
// src/views/map_barrier/ancient_level_editor.vue